import { render } from "./Messageedit.vue?vue&type=template&id=673cf294&ts=true"
import script from "./Messageedit.vue?vue&type=script&lang=ts"
export * from "./Messageedit.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src1530414395/src/mediadept-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__